import deepmerge from 'deepmerge';
import type { IConfig, IPartialConfig } from './configModel';
import {
  defaultConfiguration,
  customMergeHandlers,
} from './defaultConfiguration';

const overwriteMerge = (
  _destinationArray: unknown[],
  sourceArray: unknown[],
  _options: unknown
) => sourceArray;

export type MergeHandlerMap<T> = {
  [P in keyof T]: (
    target: Partial<T[P]>,
    source: Partial<T[P]>
  ) => Partial<T[P]>;
};

export const mergeConfigs = <T extends IPartialConfig>(...configs: T[]): T =>
  deepmerge.all<T>([{}, ...configs], {
    arrayMerge: overwriteMerge,
    customMerge: (key) => customMergeHandlers[key],
  });

export const mergeConfigsWithDefault = <T extends IPartialConfig>(
  ...configs: T[]
): IConfig => {
  return mergeConfigs<IPartialConfig>(
    defaultConfiguration as IPartialConfig,
    ...configs
  ) as IConfig;
};
